import { useTranslation } from "react-i18next";
import { filterServiceRolesForEmployeeType, isLicenseRequiredForEmployee } from "../../../../Utils/vonEmployeeUtils";
import { Dropdown } from "../../../FormComponents/Dropdown";

const VonEditEmployeeRolesForm = ({ form, onChange, vonAccount, vonProducts, vonAccounts, vonEmployeeTypeRestrictions }) => {
    const { t } = useTranslation();
    const { data } = form;
    const employeeWillConsumeLicense = isLicenseRequiredForEmployee(vonAccount, vonEmployeeTypeRestrictions);

    const getService = (productNumber) => data.services.find(s => s.serviceId === productNumber);

    const countActiveUsersForProduct = (product) => {
        const activeUsersCount = vonAccounts.filter(account =>
            account.id !== vonAccount.id &&
            account.roles.some(role => role.applicationId === product.productNumber) &&
            isLicenseRequiredForEmployee(account, vonEmployeeTypeRestrictions)
        ).length;

        return activeUsersCount + (employeeWillConsumeLicense && getService(product.productNumber)?.roleId ? 1 : 0);
    };

    const onChangeAccessRight = (roleId, product) => {
        const service = getService(product.productNumber);

        const updatedServices = service
            ? data.services.map(x => x.serviceId === service.serviceId ? { ...x, roleId: roleId == 0 ? null : roleId } : x)
            : [...data.services, { serviceId: product.productNumber, roleId }];

        onChange(form.id, updatedServices, 'services');
    };

    const renderProductRow = (product) => {
        const service = getService(product.productNumber);
        const activeUserCount = countActiveUsersForProduct(product);
        const isLicenseProduct = product.licenses !== 0;
        const options = filterServiceRolesForEmployeeType(vonAccount.employeeType, product.vonServiceRoles, vonEmployeeTypeRestrictions);
        const isDisabled = options.length <= 1 || (isLicenseProduct && employeeWillConsumeLicense && activeUserCount >= product.licenses && !service?.roleId);

        return (
            <div key={product.productNumber} className="d-flex align-items-end">
                <div className="col-6">
                    <label>{product.product}</label>
                    <Dropdown
                        options={options}
                        property="displayName"
                        value={service?.roleId || 0}
                        onChange={(roleId) => onChangeAccessRight(roleId, product)}
                        disabled={isDisabled}
                    />
                </div>
                {isLicenseProduct && (
                    <div>
                        <span>{activeUserCount} av {product.licenses} licenser används</span>
                    </div>
                )}
            </div>
        );
    };

    return (
        <div>
            <fieldset className={`d-grid gap-16 col mb-0`}>
                <legend>{t('vonaccountformcontainer.functionaccess')}</legend>
                {vonProducts.map(product => renderProductRow(product))}
            </fieldset>
        </div>
    );
};

export default VonEditEmployeeRolesForm;